module.exports = __webpack_public_path__ + "static/banner-desktop-empaques-505228f6453dacb13a366dfb77124642.webp";